export default __webpack_public_path__ + "static/media/naidi-2-2.e1c42803.svg";